import {loginByname, Validatecaptcha, signUp, getUsersRoles, getCaptcha, sendEmailVerify, visitorLogin} from 'api/login'
import {getUserListByParam, modifyUserPassWordByUserId, getUserInfo, modifyUserInfo, modifyUserEmail, getRoleByUser, getUserInfoByName, getUmsLogUserInvite, getUmsLogUserInviteCount, updateUmsLogUserInvite, createUserToProjects, Avatar, saveUserLiked} from 'api/users'
import {getToken, setToken, removeToken, getPermissionToken, setPermissionToken, removePermissionToken} from 'utils/token'
import { setUserInfos, setResetUserInfos } from 'utils/cache'
const users = {
  state: {
    username: '',
    userInfo: {},
    token: getToken(),
    permissionToken: getPermissionToken(),
    roles: [],
    privilage: [],
    privilage_grade: [],
    identifyUrl: '',
    resetUserInfo: {},
    modityUserBaseInfo: {},
    labInfo: [],
    labPrivilage: '',
    // save status
    processSaveStatus: false,
    globalMessage: [],
    globalMessageMaxValue: 0
  },
  mutations: {
    GENERATESTATUS (state, view) {
      console.log(view)
      state[view.key] = view.status
    },
    SET_GLOBALMESSAGE (state, res) {
      state.globalMessage = res.result
      state.globalMessageMaxValue = res.result.length
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_PERMISSIONTOKEN: (state, token) => {
      state.permissionToken = token
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_USERINFO (state, res) {
      state.userInfo = res
    },
    SET_ROLES (state, res) {
      state.roles = res
    },
    SET_LABINFO (state, res) {
      state.labInfo.push(res)
    },
    SET_PERIVILAGE: (state, perivilage) => {
      state.privilage = perivilage
    },
    SET_PRIVILAGE_GRADE: (state, grade) => {
      state.privilage_grade = grade
    },
    SET_IDENTFYURL: (state, url) => {
      state.identifyUrl = url
    },
    SET_VERIFYEMAIL: (state, data) => {
      state.resetUserInfo = data
    },
    SET_MODIFYUSERBASEINFO: (state, list) => {
      state.modityUserBaseInfo = list
    },
    SET_LABPRIVILAGE: (state, list) => {
      state.labPrivilage = list
    }
  },
  actions: {
    getUserInfoByName ({commit}, params) {
      return new Promise((resolve, reject) => {
        getUserInfoByName(params).then((res) => {
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    saveUserLiked ({commit}, data) {
      return new Promise((resolve, reject) => {
        saveUserLiked(data).then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getIdentifyCode ({commit}) {
      return new Promise((resolve, reject) => {
        getCaptcha().then((res) => {
          commit('SET_IDENTFYURL')
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    sendEmailVerify ({commit}, data) {
      return new Promise((resolve, reject) => {
        sendEmailVerify(data).then((res) => {
          console.log(res.result.user)
          commit('SET_VERIFYEMAIL')
          setResetUserInfos(JSON.stringify({
            nickName: res.result.user.nickName,
            email: res.result.user.email,
            userId: res.result.user.id
          }))
          resolve(res.result.user)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONTOKEN', '')
        removeToken()
        removePermissionToken()
        resolve()
      })
    },
    login ({commit}, params) {
      return new Promise((resolve, reject) => {
        loginByname(params).then(response => {
          console.log(response)
          setToken(response.fhSessionId)
          commit('SET_USERINFO', response.result)
          commit('SET_TOKEN', response.fhSessionId)
          setUserInfos(JSON.stringify({
            nickName: response.result.nickName,
            avatar: response.result.avatar,
            userId: response.result.userId,
            email: response.result.email
          }))
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    visitorLogin ({commit}, params) {
      return new Promise((resolve, reject) => {
        visitorLogin(params).then(response => {
          console.log(response)
          setToken(response.fhSessionId)
          commit('SET_USERINFO', response.result)
          commit('SET_TOKEN', response.fhSessionId)
          setUserInfos(JSON.stringify({
            nickName: response.result.nickName,
            avatar: response.result.avatar,
            userId: response.result.userId,
            email: response.result.email
          }))
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUsersRoles ({commit}, params) {
      return new Promise((resolve, reject) => {
        getUsersRoles(params).then(response => {
          console.log(response)
          commit('SET_PERIVILAGE', response.result.privilage)
          commit('SET_ROLES', response.result.role)
          commit('SET_PRIVILAGE_GRADE', response.result.projectGrade)
          commit('SET_LABINFO', response.result.labInfo)
          commit('SET_LABPRIVILAGE', response.result.labPrivilage)
          resolve(response.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getPermissionId ({commit}) {
      return new Promise((resolve, reject) => {
        getRoleByUser().then((res) => {
          setPermissionToken(res.result.permissionId)
          commit('SET_PERMISSIONTOKEN', res.result.permissionId)
          resolve(res)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    Validatecaptcha ({commit}, params) {
      return new Promise((resolve, reject) => {
        Validatecaptcha(params).then(response => {
          resolve(Response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    signUp ({commit}, params) {
      return new Promise((resolve, reject) => {
        signUp(params).then(response => {
          // console.log(response)
          resolve(Response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    changeUserRoles ({commit, dispatch}) {
      commit('SET_ROLES', ['admin'])
      dispatch('generateRoutes', {roles: ['admin']})
    },
    getUserListByParam ({commit}, params) {
      return new Promise((resolve, reject) => {
        getUserListByParam(params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    modifyUserPassWord ({commit}, data) {
      return new Promise((resolve, reject) => {
        modifyUserPassWordByUserId(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUserBaseInfo ({commit}) {
      return new Promise((resolve, reject) => {
        getUserInfo().then((res) => {
          resolve(res.result.userInfo)
        }).catch(error => {
          reject(error)
        })
      })
    },
    modifyUserBaseInfo ({commit}, data) {
      return new Promise((resolve, reject) => {
        modifyUserInfo(data).then((res) => {
          console.log(res)
          commit('SET_MODIFYUSERBASEINFO', data)
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    verifyPassword ({commit}, data) {
      return new Promise((resolve, reject) => {
        modifyUserEmail(data).then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getMessageGlobal ({commit}, data) {
      return new Promise((resolve, reject) => {
        getUmsLogUserInvite(data).then((res) => {
          commit('SET_GLOBALMESSAGE', res)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUmsLogUserInvite ({commit}, data) {
      return new Promise((resolve, reject) => {
        getUmsLogUserInvite(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUmsLogUserInviteCount ({commit}, data) {
      return new Promise((resolve, reject) => {
        getUmsLogUserInviteCount(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateUmsLogUserInvite ({commit}, data) {
      return new Promise((resolve, reject) => {
        updateUmsLogUserInvite(data).then((res) => {
          console.log(res)
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createUserToProjects ({commit}, data) {
      return new Promise((resolve, reject) => {
        createUserToProjects(data).then((res) => {
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    Avatar ({commit}) {
      return new Promise((resolve, reject) => {
        Avatar().then((res) => {
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    generateSaveStatus ({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('GENERATESTATUS', view)
        resolve(state[view.key])
      })
    }
  }
}

export default users



// WEBPACK FOOTER //
// ./src/store/modules/users.js